export const NffReportExclusionPnHeader = [
  {
    header: "PN",
    key: "PN",
    width: 25,
  },
  {
    header: "CUSTOMER",
    key: "CUSTOMER",
  },
  {
    header: "FLEET TYPE",
    key: "FLEET TYPE",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
];

export const NffReportExclusionPnExcelName = "NFF Report Exclusion PN List";
